import { Scene } from 'phaser';
import Container = Phaser.GameObjects.Container;
import GameObject = Phaser.GameObjects.GameObject;
import Sprite = Phaser.GameObjects.Sprite;

export class ObjectPool extends Container {
    public pool: Sprite[] = [];
    private lastElement: Sprite;

    constructor(
        parent: Container,
        private atlasName: string,
        private dirName: string,
        private dirCount: number,
        private dist: number,
        y: number,
    ) {
        super(parent.scene);

        for (let i = 0; i < dirCount; i++) this.createElement(i);
        for (let i = 0; i < dirCount; i++) this.createElement(i);
        // for (let i = 0; i < dirCount; i++) this.createElement(i);
        const { width, height } = this.scene.scale;
        this.pool.forEach((e, i) => {
            e.x = i * dist;
            this.add(e);
            this.lastElement = e;
        });
        parent.add(this);
        this.y = y;
    }

    public delete(e: Sprite) {
        this.remove(e);
    }

    public get() {
        const { atlasName, dirName, dirCount } = this;
        let element = this.pool.find((c) => !c.parentContainer);
        if (!element) {
            const i = Phaser.Math.Between(0, dirCount);
            element = this.createElement(i);
        }
        this.add(element);
        element.x = this.lastElement.x + this.dist + Phaser.Math.Between(10, 50);
        this.lastElement = element;
        // this.globalOffset = offsetX;

        return element;
    }

    private createElement(i: number): Sprite {
        const { atlasName, dirName } = this;
        const sprite = this.scene.add.sprite(0, 0, atlasName, `${dirName}/${i}.png`);
        sprite.setOrigin(0.5, 1);
        this.pool.push(sprite);
        return sprite;
    }
}
